const config = {
    apiUrl: 'https://api-eap.eldt.com/api',
    googleSignIn: 'https://api-eap.eldt.com/oauth/google?target=react',
    angularClientUrl: 'https://eap.eldt.com',
    amplitudeApiKey: '',
    defaultCompanyId: 73,
    defaultLocationId: 18,
    packageIds: {
        'Class A': 22,
        'Class B': 20,
        'Class B-A': 21,
        'None': 19,
    },
    stripePublicKey: 'pk_test_51KVilWEqooDHZwmck4VuUymwm3Bw75Fuyryrd0o3MiIlhowWiYpgJg0RgyrNIKufGU4lwTGYZxoIcsSSgP2ZaDmJ00Lb7M2O9G',
    sentryKey: 'https://3bc1b8796a1a55caad7558064170639b@o4503932842999808.ingest.us.sentry.io/4508354754379776',
}

export default config;
